import API from './api';

export const projectService = {
  // Get all projects
  getProjects: async () => {
    try {
      const response = await API.get('/projects');
      return response.data;
    } catch (error) {
      console.error('Get projects error:', error);
      throw error;
    }
  },

  // Get project list for dropdown
  getProjectList: async () => {
    try {
      const response = await API.get('/projects/project-list');
      return response.data;
    } catch (error) {
      console.error('Get project list error:', error);
      throw error;
    }
  },

  // Create new project (Admin only)
  createProject: async (projectData) => {
    try {
      const response = await API.post('/projects', projectData);
      return response.data;
    } catch (error) {
      console.error('Create project error:', error);
      throw error;
    }
  },

  // Update project (Admin only)
  updateProject: async (projectId, projectData) => {
    try {
      const response = await API.put(`/projects/${projectId}`, projectData);
      return response.data;
    } catch (error) {
      console.error('Update project error:', error);
      throw error;
    }
  },

  // Delete project (Admin only)
  deleteProject: async (projectId) => {
    try {
      const response = await API.delete(`/projects/${projectId}`);
      return response.data;
    } catch (error) {
      console.error('Delete project error:', error);
      throw error;
    }
  }
};

export default projectService;